'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m5.455 16.244 1.488.363a19.667 19.667 0 0 0 1.973 14.322l.188.324-1.32.78a21.193 21.193 0 0 1-2.329-15.789Zm2.844 1.963 1.505.29a16.254 16.254 0 0 0 1.034 9.483l.146.33-1.393.637A17.785 17.785 0 0 1 8.3 18.207Zm36.135 7.538 1.48.393c-.175.66-.384 1.315-.626 1.964l-.187.485-1.422-.57c.3-.749.552-1.507.755-2.272Zm.607-3.622 1.528.11c-.044.615-.115 1.23-.214 1.843l-.08.458-1.506-.278c.13-.707.221-1.42.272-2.133Zm1.478-3.494c.053.529.086 1.061.099 1.595l.006.535-1.532-.001c0-.497-.017-.993-.054-1.485l-.043-.49 1.524-.154Zm-3.33-.698c.077.564.127 1.13.15 1.696l.01.426-1.531.022c-.007-.485-.037-.97-.088-1.454l-.058-.484 1.517-.206ZM37.983 3.659a21.192 21.192 0 0 1 8.29 13.238l.063.361-1.51.252a19.667 19.667 0 0 0-7.463-12.402l-.286-.214.906-1.235ZM9.299 14.85l1.418.58c-.185.451-.349.91-.492 1.374l-.135.466-1.477-.407a17.71 17.71 0 0 1 .686-2.013Zm28.237-7.797a17.777 17.777 0 0 1 5.33 9.006l.082.36-1.497.325a16.244 16.244 0 0 0-4.68-8.311l-.265-.245 1.03-1.135ZM6.57 12.911l1.407.606c-.195.453-.373.914-.534 1.383l-.155.471-1.46-.46c.214-.68.461-1.348.742-2Zm1.804-3.333 1.276.848c-.299.45-.578.91-.837 1.38l-.253.474-1.362-.702c.354-.686.746-1.353 1.176-2Zm2.675-3.264 1.083 1.083a19.9 19.9 0 0 0-1.29 1.42l-.299.372-1.206-.945a21.4 21.4 0 0 1 1.712-1.93Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "#3F3E4B",
    fill: "#FFF",
    d: "m20.578 41.494 6.082 4.425 21.7-9.294-6.224-4.507zM31.257 30.952l-7.004-4.03-21.7 9.295L9.67 40.31z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M25.457 8.052c-7.525 0-13.624 6.1-13.624 13.624a13.57 13.57 0 0 0 3.469 9.08l8.95-3.834 7.005 4.03 3.784.406a13.583 13.583 0 0 0 4.04-9.682c0-7.525-6.1-13.624-13.624-13.624",
    fill: "currentColor",
    opacity: 0.3
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m31.498 30.207-7.195-4.14-23.46 10.05 8.583 4.937 10.866 1.18 6.27 4.56 23.341-9.997-7.482-5.418-10.923-1.172Zm-27.234 6.11 19.939-8.54 6.812 3.92 10.837 1.161 4.964 3.594-20.058 8.591-5.895-4.288-10.953-1.19-5.646-3.248Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M25.87 36.474c.252-7.21 7.157-8.997 7.157-14.89a7.573 7.573 0 0 0-8.55-7.509c-3.948.496-6.864 4.08-6.571 8.048.404 5.472 6.894 7.366 7.137 14.351",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.381 13.315c5.032-.631 9.412 3.26 9.412 8.27 0 2.32-.814 3.983-2.73 6.328l-.353.426-.679.806c-2.282 2.714-3.235 4.467-3.383 7.082l-.013.274-1.179-.041-1.178.041c-.094-2.677-.973-4.429-3.165-7.079l-1.053-1.254c-1.905-2.287-2.76-3.848-2.918-5.988-.324-4.378 2.89-8.319 7.239-8.865Zm7.88 8.27c0-4.09-3.574-7.266-7.69-6.75-3.538.445-6.165 3.666-5.901 7.232.119 1.608.742 2.854 2.188 4.658l.466.566.73.868c1.762 2.094 2.823 3.718 3.35 5.565l.052.191.052-.19c.504-1.764 1.494-3.324 3.115-5.284l1.054-1.254c1.857-2.23 2.584-3.646 2.584-5.603Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.754 21.676a2.297 2.297 0 1 1-4.595 0 2.297 2.297 0 0 1 4.595 0",
    fill: "#FFF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M25.457 18.613a3.064 3.064 0 1 0 0 6.127 3.064 3.064 0 0 0 0-6.127Zm0 1.532a1.531 1.531 0 1 1 0 3.063 1.531 1.531 0 0 1 0-3.063Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  })));
});
var RealtySite = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.RealtySite = RealtySite;